require('./bootstrap');
require('./_global');
require('./components/vue-declarator');
require('./helpers/subprojects-grid-loader');
window.TaskSheetsGrid = require('./helpers/task-sheets-grid');
window.WorkingBlocksCanvas = require('./working-blocks/canvas');
window.WorkingBlocksPlanning = require('./working-blocks/planning');

// Import e inizializza gli handler
import PropagationHandler from './handlers/propagation-handler';
import TimeReportsHandler from './handlers/time-reports-handler';
import ChartsHandler from './handlers/charts-handler';
import './handlers/dashboard-v2-handler';
import './handlers/my-brain-dashboard-charts';

// Funzione per inizializzare gli handler
function initializeHandlers() {
    try {
        new PropagationHandler();
        new TimeReportsHandler();
        // Crea un'istanza globale del ChartsHandler per debugging
        window.chartsHandler = new ChartsHandler();
    } catch (error) {
        console.error('Errore durante l\'inizializzazione degli handler:', error);
    }
}

// Inizializza gli handler quando il DOM è pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHandlers);
} else {
    initializeHandlers();
}
